$(() => $('table.table-row-clickable tr[data-url]').addClass('clickable-row').delegate('*', 'click', function (e) {
  if ((this.tagName === 'TD' || this.tagName === 'TR') && !$(this).hasClass('unclickable-cell')) {
    window.location.href = $(this).parents('tr').data('url');
  }
  e.stopPropagation();
}));
